export default __webpack_public_path__ + "static/media/025-liberty bell.be28c847.svg";